import "@/App.css";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyMe from "@/components/WhyMe";
import Portfolio from "@/components/Portfolio";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white text-[#0F172A]">
        <Navigation />
        <main>
          <Hero />
          <About />
          <Services />
          <WhyMe />
          <Portfolio />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
